import React, { useState, useEffect } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import CheckLogin from './CheckLogin'
import { useNavigate } from 'react-router-dom'
import logo from '../../../images/logotime1.png'

import "./rewardStyle.css"

export default function Sidebar(props) {
  const [selectedOption, setSelectedOption] = useState(false)
  const location = useLocation();

  const navigate = useNavigate()
  const get_userid = sessionStorage.getItem('userid')
  if (get_userid == "" || get_userid == "0") {
    navigate('/login');
  }

  useEffect(() => {
    if (
      location.pathname === '/my-account/quick-quote' || 
      location.pathname === '/my-account/multiple-quick-quote' || 
      location.pathname === '/my-account/document-quote' || 
      location.pathname === '/my-account/multiple-document-quote' || 
      location.pathname === '/my-account/domestic-quote' ||
      location.pathname === '/my-account/heavy-quick-quote' ||
      location.pathname === '/my-account/heavy-document-quote' 
    ) {
      setSelectedOption(true)
    }
  }, [])

  return (
    <div id="admin-sidebar" className={`col-md-3 sidebar ${props.isOpen ? 'openSidebar' : ''}`} style={{ backgroundColor: "#1c2434", overflow: "auto" }}>
      <Link className="offset-1 navbar-brand headerlogo" to="/"><img src={logo} style={{ width: "50%", paddingLeft: "10px", paddingTop: "5%", paddingBottom: "5%" }} /></Link>
      <CheckLogin />
      <ul className="sidenav admin-sidenav list-unstyled" style={{ marginTop: "20px" }}>
        <li><NavLink to="/my-account/dashboard" style={{ textAlign: "left", marginLeft: "25px" }}>Dashboard</NavLink></li>
        <li><NavLink to="/my-account/my-parcels" style={{ textAlign: "left", marginLeft: "25px" }}>My Parcels</NavLink></li>
        <li>
          <a onClick={() => setSelectedOption(!selectedOption)} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginLeft: "25px", color: "white", cursor: "pointer" }}>
            <span>
              Get a Quote
            </span>
            {
              selectedOption ?
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.41107 6.9107C4.73651 6.58527 5.26414 6.58527 5.58958 6.9107L10.0003 11.3214L14.4111 6.91071C14.7365 6.58527 15.2641 6.58527 15.5896 6.91071C15.915 7.23614 15.915 7.76378 15.5896 8.08922L10.5896 13.0892C10.2641 13.4147 9.73651 13.4147 9.41107 13.0892L4.41107 8.08922C4.08563 7.76378 4.08563 7.23614 4.41107 6.9107Z"
                    fill="#FFFFFF"
                    transform="rotate(180 10 10)"
                  />
                </svg> :
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.41107 6.9107C4.73651 6.58527 5.26414 6.58527 5.58958 6.9107L10.0003 11.3214L14.4111 6.91071C14.7365 6.58527 15.2641 6.58527 15.5896 6.91071C15.915 7.23614 15.915 7.76378 15.5896 8.08922L10.5896 13.0892C10.2641 13.4147 9.73651 13.4147 9.41107 13.0892L4.41107 8.08922C4.08563 7.76378 4.08563 7.23614 4.41107 6.9107Z"
                    fill="#FFFFFF"
                  />
                </svg>
            }
          </a>
        </li>
        {
          selectedOption && <>
            <li><NavLink to="/my-account/quick-quote" style={{ textAlign: "left", marginLeft: "50px" }}>Package</NavLink></li>
            <li><NavLink to="/my-account/multiple-quick-quote" style={{ textAlign: "left", marginLeft: "50px" }}>Multi Package</NavLink></li>
            {/* <li><NavLink to="/my-account/heavy-quick-quote" style={{ textAlign: "left", marginLeft: "50px" }}>Heavy Pallet</NavLink></li> */}
            <li><NavLink to="/my-account/document-quote" style={{ textAlign: "left", marginLeft: "50px" }}>Document</NavLink></li>
            <li><NavLink to="/my-account/multiple-document-quote" style={{ textAlign: "left", marginLeft: "50px" }}>Multi Document</NavLink></li>
            <li><NavLink to="/my-account/heavy-document-quote" style={{ textAlign: "left", marginLeft: "50px" }}>Heavy Shipment</NavLink></li>
            <li><NavLink to="/my-account/domestic-quote" style={{ textAlign: "left", marginLeft: "50px" }}>Domestic</NavLink></li>
          </>
        }
        {/* {corporate_customer && corporate_customer > 0 ? (
          <li><NavLink to="/my-account/bulk-upload/">BULK UPLOAD</NavLink></li>
        ) : null} */}
        <li><NavLink to="/track" style={{ textAlign: "left", marginLeft: "25px" }}>Track</NavLink></li>
        <li><NavLink to="/my-account/my-wallet/" style={{ textAlign: "left", marginLeft: "25px" }}>My Wallet</NavLink></li>
        <li><NavLink to="/my-account/address-book" style={{ textAlign: "left", marginLeft: "25px" }}>Address Book</NavLink></li>
        <li><NavLink to="/my-account/settings" style={{ textAlign: "left", marginLeft: "25px" }}>Settings</NavLink></li>
      </ul>

    </div>
  )
}
